module.exports = __webpack_public_path__ + "media/public/fonts/QanelasLight/QanelasLight-af63bc15bd50bcb9ea4e4203703cc1df.eot";